export const geoApiOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "fd7650ed19mshee1107da51edddcp1b9dfcjsn2891e08eae08", // enter your rapid api key here
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
  },
};
export const GEO_API_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const WEATHER_API_URL = "https://api.openweathermap.org/data/2.5";
export const WEATHER_API_KEY = "ebb3a0fa25cce2ca403b1b8d8277a640"; // enter your key from openweather API
